module.exports = __webpack_public_path__ + "static/quiz_input_name_title_bg-9fa5ef8f16fb886546d2f1cb27f47a5e.svg";